var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartElem"},[_c('div',{staticClass:"row"},[(_vm.stats!=null)?[_c('highcharts',{staticStyle:{"width":"100%"},attrs:{"options":_vm.chartOptions(_vm.onClickChartPoint)}})]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }